// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, new-cap, babel/new-cap, no-unreachable */
import { List } from "immutable"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import Journey from "@kiwicom/frontend-common/records/Journey"
import mapperJourney from "@kiwicom/frontend-common/services/journey/mapperJourney"
import apiBookingTokens from "@kiwicom/frontend-common/services/apiBookingTokens/apiBookingTokens"
import type { Airlines } from "@kiwicom/frontend-common/records/Airline"

import Booking from "../../records/Booking"
import type { RefundByUuidOutbound } from "../../types/outbound"
import type { ViaSupportCategory } from "../../consts/additionalServices"
import type { BookingInput } from "../../records/bookingInput"
import mapperManageBooking from "../../scenes/AccountBooking/components/Booking/services/mapper/mapperManageBooking"
import type { BookingId } from "../../types/primitiveTypes"
import mapperAncillaries from "../../scenes/AccountBooking/components/Booking/services/mapper/services/mapperAncillaries"
import trackInvalidBookingData from "../../scenes/AccountBooking/components/Booking/services/utils/trackInvalidBookingData"
import { apiUrl, fetchWithSniff, transport } from "../api/transport"
import mmbTrack from "../tracking/mmbTrack"
import { BookingLoadRetryAction, GeneralModule } from "../tracking/constants/trackingEvents"
import createAlternativePayload from "../../scenes/AccountBooking/components/Booking/scenes/BookingJourneyChange/services/createAlternativePayload"
import type {
  ItineraryChangeSearchForm,
  ItineraryChangeSearchFormFilters,
} from "../../scenes/AccountBooking/components/Booking/scenes/BookingJourneyChange/services/AlternativeFlightsDuck.types"
import mapperAncillariesOffers from "../../scenes/AccountBooking/components/Booking/services/mapper/services/mapperAncillariesOffers"

const ROUTE = "api/v0.1/users/self/bookings"

export type additionalServicesRequestForm = {
  category: ViaSupportCategory
  values: {
    message?: string
    type?: string
    width?: string
    height?: string
    weight?: string
    different?: string
  }
}

export type PassengerChanges = {
  passenger_changes: Partial<
    Record<
      number | string,
      {
        birthdate?: string
        document_expiration?: string
        document_number?: string
        files?: string[]
        first_name?: string
        last_name?: string
        middle_name?: string
        nationality?: string
        title?: string
      }
    >
  >
}

// const HEADER_PARTNER_TOKEN = "KW-Partner-Token"

export function detectSector(booking: Booking, selected: Journey): number | null | undefined {
  // @ts-expect-error: Flow to TS migration.
  const originalTrips = booking.journey.get("trips")
  const selectedTrips = selected.get("trips")
  if (originalTrips.size !== selectedTrips.size) {
    return originalTrips.indexOf(selectedTrips.first())
  }
  return undefined
}

export const findOne = (
  bid: BookingId,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  locale: string = "en",
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  retry: number = 3,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  retryTimeout: number = 5000,
): Promise<Booking> => {
  // APMs payment can cause delay in saving booking => give 'status: null' after payment 3 attempts
  // (default number of retries in other cases)
  return transport("GET", bid, `/${ROUTE}/${bid}`, { locale }, null, 0).then(
    (booking: BookingInput) => {
      if (!booking.status && retry >= 0) {
        cuckoo.track(cuckooEvents.MMB_LOAD_BOOKING_STATUS_NULL, { numberOfRetries: -(retry - 3) })
        mmbTrack({ module: GeneralModule, action: BookingLoadRetryAction })

        return new Promise((resolve: (result: Promise<never>) => void) => {
          setTimeout(() => {
            // @ts-expect-error: Flow to TS migration.
            resolve(findOne(bid, locale, retry - 1, retryTimeout + 1000))
          }, retryTimeout)
        })
      }
      apiBookingTokens.add(booking.bid, booking.auth_token) // force using simple_token for loading bookings

      const mappedBooking = mapperManageBooking(booking)
      trackInvalidBookingData(mappedBooking)
      return mappedBooking
    },
  )
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const edit = (bid: BookingId, payload: any) =>
  transport("POST", bid, `/${ROUTE}/edit/${bid}`, null, payload)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const action = (actionName: string, bid: BookingId, data: any) =>
  transport("POST", bid, `/${ROUTE}/${bid}`, null, { action: actionName, data })

export const additionalServicesRequest = (booking: Booking, form: additionalServicesRequestForm) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  transport("POST", booking.id, `/api/v0.1/additional_services_request/${booking.id}`, null, form)

export const findAlternatives = (
  booking: Booking,
  selected: Journey,
  searchForm: ItineraryChangeSearchForm,
  filters: ItineraryChangeSearchFormFilters,
  airlines: Airlines,
  partner?: string,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const queryPayload = createAlternativePayload(
    booking,
    searchForm,
    detectSector(booking, selected),
    filters,
    partner,
  )
  return transport(
    "GET",
    // @ts-expect-error: Flow to TS migration.
    booking.id,
    // Fix this the next time the file is edited. (Flow to TS)
    // @ts-expect-error: Flow to TS migration.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `/mmb/v1/bookings/${booking.id}/itinerary_changes/offer`,
    queryPayload,
    // @ts-expect-error: Flow to TS migration.
  ).then((res) => List(res.data.map((j) => mapperJourney(j, "", false, airlines))))
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkFlight = (booking: Booking, selected: Journey): Promise<any> => {
  // Disable check flights due to BE bug
  // https://gitlab.skypicker.com/booking/backend/issues/4321
  return Promise.resolve()

  return fetchWithSniff(`${apiUrl()}/api/v0.1/check_flights`, {
    query: {
      booking_token: selected.get("bookingToken"),
      // @ts-expect-error: Flow to TS migration.
      bnum: booking.bags,
      pnum: 1, // API nonsense - pnum is in "bookingToken"
    },
  })
}

export const submitForm = (booking: Booking, selected: Journey, form: Booking) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  transport("POST", booking.id, `/api/v0.1/alternative_route_request/${booking.id}`, null, {
    ...form,
    segment: detectSector(booking, selected),
  })

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const fetchThirdPartyAncillaries = (bid: number, currency: string = "EUR") =>
  // @ts-expect-error: Flow to TS migration.
  transport(
    "GET",
    bid,
    `/mmb/v1/bookings/${bid}/ancillaries${currency ? `?currency=${currency}` : ""}`,
  ).then((res) => mapperAncillaries(res))

export const fetchThirdPartyAncillariesOffers = (
  bid: number,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataAdapter: (arg1?: any) => any = (data: any) => data,
) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/ancillaries/offers/check`, null, {
    ancillaries: ["axa_insurance", "guarantee"],
    currency: "EUR",
    language: "en",
  }).then((res) => dataAdapter(mapperAncillariesOffers(res)))

export const submitPassengerEditFrom = (bid: BookingId, payload: PassengerChanges) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/passengers/change_requests`, null, payload)

export const getPassengerEditRequestDetail = (bid: BookingId, requestId: number) =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/passengers/change_requests/${requestId}`, null)

export const deletePassengerEditRequestDetail = (bid: BookingId, requestId: number) =>
  transport("DELETE", bid, `/mmb/v1/bookings/${bid}/passengers/change_requests/${requestId}`, null)

export const postRefundByUUIDs = (bid: BookingId, payload: RefundByUuidOutbound) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/refunds`, null, payload)
